"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var PaymentMethods = function () {
    return (0, jsx_runtime_1.jsxs)("div", __assign({ class: "flex flex-row flex-wrap items-center w-full justify-between gap-1" }, { children: [(0, jsx_runtime_1.jsx)("img", { src: "/assets/images/payments/visa.svg", width: "40" }), (0, jsx_runtime_1.jsx)("img", { src: "/assets/images/payments/mastercard.svg", width: "40" }), (0, jsx_runtime_1.jsx)("img", { src: "/assets/images/payments/paypal.svg", width: "40" }), (0, jsx_runtime_1.jsx)("img", { src: "/assets/images/payments/applepay.svg", width: "40" }), (0, jsx_runtime_1.jsx)("img", { src: "/assets/images/payments/googlepay.svg", width: "40" }), (0, jsx_runtime_1.jsx)("img", { src: "/assets/images/payments/klarna.svg", width: "40" })] }));
};
exports.default = PaymentMethods;
